module.exports = __webpack_public_path__ + "static/img/tongyong_js_01.4acd73c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tongyong_js_01.png
// module id = dGSw
// module chunks = 0